import { POST_MASONRY_FLOW_STEP } from '@leagueplatform/masonry-api';
import {
  MasonryDriverAction,
  MasonrySubmitFlowStepAction,
} from '@leagueplatform/masonry-renderers';
import { MasonryEngineActionHandler } from '@leagueplatform/masonry-engine';
import { filterFieldsToCurrentStep } from './validate-flow-step';
import { getVisibleFormFieldNodes } from '../utils/form-validation-utils';
import { submitFormWithValidation } from '../utils/form-submission-base';

/**
 * Flow step submit action handler
 *
 * This handler works like the regular form submit handler, but filters form fields
 * to only include those that are descendants of the current step node.
 */
export const SubmitFlowStepActionHandler: MasonryEngineActionHandler<
  MasonrySubmitFlowStepAction,
  MasonryDriverAction
> = async (
  {
    payload: { formId, formProcessorId, isBlocking },
    namespace,
    ancestry,
    event,
  },
  resources,
) => {
  const { messagingController, stateController } = resources;
  const allFieldNodes = getVisibleFormFieldNodes(formId, stateController);

  // Apply custom field filtering logic
  const fieldNodes = filterFieldsToCurrentStep({
    allFieldNodes,
    formId,
    stateController,
    messagingController,
  });
  return submitFormWithValidation({
    formId,
    formProcessorId,
    fieldNodes,
    baseEndpoint: POST_MASONRY_FLOW_STEP,
    namespace,
    ancestry,
    event,
    resources,
    isBlocking,
  });
};
